import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import CustomLink from "./custom_link";

const CustomLinks = ({ customLinks, onCustomLinksUpdate, formErrors }) => {
  const { t } = useTranslation("saasAdmin");
  const handleChange = (index, field, value) => {
    const updatedLinks = [...customLinks];
    updatedLinks[index][field] = value;
    onCustomLinksUpdate(updatedLinks);
  };

  const handleNewCustomLink = () => {
    const updatedLinks = [...customLinks];
    updatedLinks.push({ title: "", url: "", id: Date.now() });
    onCustomLinksUpdate(updatedLinks);
  };

  const handleRemove = (customLinkid) => {
    const updatedLinks = [...customLinks];
    const customLinkIndex = updatedLinks.findIndex((link) => link.id === customLinkid);
    if (customLinkIndex > -1) {
      updatedLinks.splice(customLinkIndex, 1);
      onCustomLinksUpdate(updatedLinks);
    }
  };

  return (
    <>
      <h2>{t("customization.customLinks.header")}</h2>
      {customLinks.map((customLink, index) => (
        <CustomLink
          key={`custom_link_${customLink.id}`}
          title={customLink.title}
          url={customLink.url}
          handleChange={(field, value) => handleChange(index, field, value)}
          handleRemove={() => handleRemove(customLink.id)}
          formErrors={formErrors && formErrors[index]}
        />
      ))}
      <Button kind="primary" onClick={handleNewCustomLink} type="button">
        {t("customization.customLinks.newButton")}
      </Button>
    </>
  );
};

CustomLinks.propTypes = {
  customLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    })
  ),
  onCustomLinksUpdate: PropTypes.func.isRequired,
  formErrors: PropTypes.array
};

export default CustomLinks;
